/*
  NOTE: This helper exports a custom validation rule for the Vee Validate plugin:
  https://vee-validate.logaretm.com/v4/guide/global-validators
*/



const validateConfirmation = (value, params) => {
  const target = Array.isArray(params) ? params[0] : params.target;

  if (value === target) {
    return true;
  }

  return 'Confirmation does not match.';
};



export default validateConfirmation;
